import React, { memo } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import PaginationConfig from "../PaginationConfig";
import PaginationNumbers from "../PaginationNumbers";
import styles from "./PaginationBox.module.scss";

const PaginationBox = ({ children, className }) => {
  let paginationConfig = null;
  let paginationNumbers = null;
  React.Children.forEach(children, child => {
    if (child?.type === PaginationConfig) {
      paginationConfig = child;
    }
    if (child?.type === PaginationNumbers) {
      paginationNumbers = child;
    }
  });

  return paginationConfig || paginationNumbers ? (
    <div className={cn(styles.paginationBox, className, { [styles.center]: !paginationConfig })}>
      {paginationConfig && <div className={styles.paginationConfig}>{paginationConfig}</div>}
      {paginationNumbers && <div className={styles.pagination}>{paginationNumbers}</div>}
    </div>
  ) : null;
};

PaginationBox.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

PaginationBox.defaultProps = {
  children: null,
  className: ""
};

export default memo(PaginationBox);
